import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getState, removeAccount, setState } from '../lib/storage';

export const APP_STATE_KEY = ['appState'];

export function useAppState() {
    return useQuery({
        queryKey: APP_STATE_KEY,
        queryFn: getState,
        // Since we are using local DB, we treat it as remote for Query purposes.
        // Stale time 0 ensures we always re-read if invalidated.
        staleTime: 0,
        networkMode: 'always',
    });
}

export function useSetAppState() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: setState,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: APP_STATE_KEY }),
    });
}

export function useRemoveAccount() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: removeAccount,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: APP_STATE_KEY }),
    });
}
